import {
  docIcon,
  locationIcon,
  logoutIon,
  profileIcon,
  trashIcon,
  userProfileIcon,
} from "assets/icons";
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import LogOut, { DeleteAccount } from "./section/LogOut";
import { useSelector } from "react-redux";

const ProfileDropdown = () => {
  const [logoutModal, setLogoutModal] = useState(false);
  const [deleteAccountModal, setDeleteAccountModal] = useState(false);
  const { user, loading, error } = useSelector((state) => state.userProfile);
  // console.log('user', user)
  return (
    <>
      <Dropdown className="custom_dropdown">
        <Dropdown.Toggle variant="success" id="dropdown-basic">
          <img src={user?.user?.profile || profileIcon} alt="notification" />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item as={"span"}>
            <Link to="/account">
              <img src={userProfileIcon} alt="" />{" "}
              <span>Profile Details</span>
            </Link>
          </Dropdown.Item>
          {/* <Dropdown.Item as={"span"}>
            <Link to="/sites">
              <img src={locationIcon} alt="" /> <span>My Sites</span>
            </Link>
          </Dropdown.Item>
          <Dropdown.Item as={"span"}>
            <Link to="/document-repository">
              <img src={docIcon} alt="" /> <span>Document Repository</span>
            </Link>
          </Dropdown.Item> */}
          <Dropdown.Item as={"span"}>
            <button type="button" onClick={() => setDeleteAccountModal(true)}>
              <img src={trashIcon} alt="" />{" "}
              <span>Delete Account</span>
            </button>
          </Dropdown.Item>
          <Dropdown.Item as={"span"}>
            <button type="button" onClick={() => setLogoutModal(true)}>
              <img src={logoutIon} alt="" /> <span>Logout</span>
            </button>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <LogOut show={logoutModal} close={() => setLogoutModal(false)} />
      <DeleteAccount
        show={deleteAccountModal}
        close={() => setDeleteAccountModal(false)}
      />
    </>
  );
};

export default ProfileDropdown;
